import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Solution } from '../../../models/solution';

@Component({
  selector: 'solution-icon',
  templateUrl: './solution-icon.component.html',
  styleUrls: ['./solution-icon.component.scss']
})
export class SolutionIconComponent {

  @Input()
  solution: Solution;

  @Output()
  selected = new EventEmitter<Solution>();
  
  @Output()
  scrolling = new EventEmitter();

  selectSolution(solution: Solution) {
    this.selected.emit(solution);
  }

  constructor() { }

}
